import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Shield, Globe, ArrowUpRight } from 'lucide-react';
export function OtlVisor() {
  return <div className="mb-24" data-id="element-402" data-mp="3jr3ojq791bxv">
      <div className="max-w-3xl mb-12" data-id="element-403" data-mp="2cym3mmzxqup">
        <h3 className="font-serif text-3xl md:text-4xl text-forest mb-6" data-id="element-404" data-mp="2e19hkl41b5v">
          Visor de OTL
        </h3>
        <div className="space-y-4 text-charcoal/80 font-light leading-relaxed" data-id="element-405" data-mp="3tptabu29ngje">
          <p data-id="element-406" data-mp="bbtpkqynomub">
            El Visor de OTL es una herramienta digital que permite consultar en
            un mapa los diez objetos territoriales legales priorizados por el
            Ministerio de Ambiente. A través del visor, cualquier usuario puede
            identificar dónde se ubican estas figuras, cuáles son sus límites y
            qué información básica está asociada a ellas.
          </p>
          <p data-id="element-407" data-mp="2n37hbbxpbszb">
            Es una plataforma geográfica digital donde puedes consultar y
            visualizar en el mapa los diez objetos territoriales legales que el
            Ministerio de Ambiente ha priorizado. Allí puedes ver la ubicación
            exacta, los límites y las características de cada figura
            territorial.
          </p>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.7
    }} className="relative w-full h-[480px] md:h-[680px] bg-forest overflow-hidden mb-4" data-id="element-408" data-mp="35xgoc4opp57b">
        <iframe title="Visor de OTL — ArcGIS Experience" src="https://experience.arcgis.com/experience/2b40477aad324361a7fd7603c1eb873d" className="absolute inset-0 w-full h-full" style={{
        border: 'none'
      }} allowFullScreen loading="lazy" data-id="element-409" data-mp="3kmcv7yf18c6c" />
      </motion.div>

      <p className="text-sm text-charcoal/60 font-light mb-16" data-id="element-410" data-mp="1v8rai7bl90pa">
        Este visor y mucha más información ambiental y geográfica también está
        disponible en el{' '}
        <a href="https://datos.siac.gov.co/" target="_blank" rel="noopener noreferrer" className="text-clay font-medium hover:text-clay-light transition-colors inline-flex items-center gap-1" data-id="element-411" data-mp="1zbw7xvgtac72">
          portal de datos abiertos del SIAC
          <ArrowUpRight size={14} className="flex-none" data-id="element-412" data-mp="3blx5f7h399lj" />
        </a>{' '}
        y en{' '}
        <a href="https://www.colombiaenmapas.gov.co/" target="_blank" rel="noopener noreferrer" className="text-clay font-medium hover:text-clay-light transition-colors inline-flex items-center gap-1" data-id="element-413" data-mp="37jk02k697dpa">
          Colombia en Mapas
          <ArrowUpRight size={14} className="flex-none" data-id="element-414" data-mp="3gjykzifb2qs9" />
        </a>
        .
      </p>

      <div className="mb-12" data-id="element-415" data-mp="3v8mivvcmjcld">
        <h4 className="font-serif text-xl text-forest mb-6" data-id="element-416" data-mp="3vbqrr611awid">
          ¿Para quién es útil?
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-417" data-mp="3qcnva9z4dym0">
          <div className="flex gap-4" data-id="element-418" data-mp="85hlr0797qxc">
            <Shield className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-419" data-mp="35v84pnik8o0" />
            <div data-id="element-420" data-mp="340pjhzpssn3">
              <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-421" data-mp="mrwwtiw40505">
                Entidades públicas
              </strong>
              <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-422" data-mp="rpf83fxlmwbb">
                Que necesitan tomar decisiones basadas en información
                territorial oficial.
              </p>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-423" data-mp="huex8j3zf24t">
            <BookOpen className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-424" data-mp="40vvio7inxdf" />
            <div data-id="element-425" data-mp="8se1jqoeco59">
              <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-426" data-mp="8sxfyxeu8uej">
                Investigadores y academia
              </strong>
              <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-427" data-mp="3q6j2fpt0416b">
                Que estudian el ambiente y el ordenamiento del territorio.
              </p>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-428" data-mp="3m6shi2q5of9p">
            <Users className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-429" data-mp="3m5qssvg7vu9i" />
            <div data-id="element-430" data-mp="3e6m8mr0zfdiv">
              <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-431" data-mp="3e51dp0ar9skh">
                Organizaciones sociales
              </strong>
              <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-432" data-mp="399c8agc21hg9">
                Y comunitarias que trabajan en la defensa de sus territorios.
              </p>
            </div>
          </div>
          <div className="flex gap-4" data-id="element-433" data-mp="2vfl7pxgax7wo">
            <Globe className="text-clay flex-none mt-1" size={24} strokeWidth={1.5} data-id="element-434" data-mp="2vgmj6318bwex" />
            <div data-id="element-435" data-mp="2qg8mti8zqawq">
              <strong className="block text-charcoal font-medium mb-1 text-sm" data-id="element-436" data-mp="2qfqhlw4comco">
                Ciudadanía en general
              </strong>
              <p className="text-charcoal/70 text-sm font-light leading-relaxed" data-id="element-437" data-mp="2lj8gd688b653">
                Que quiere entender qué tipo de protección existe en un lugar
                del país.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto text-center space-y-4 text-charcoal/80 font-light leading-relaxed text-lg" data-id="element-438" data-mp="fpry1n017jl4">
        <p data-id="element-439" data-mp="1xltpji5tpocm">
          El Visor no requiere conocimientos técnicos especializados: cualquier
          persona puede navegar por el mapa, identificar las figuras
          territoriales y acceder a información oficial de forma directa.
        </p>
        <p data-id="element-440" data-mp="2be04x215jrb0">
          Los OTL son una forma de hacer más visible, comprensible y útil la
          información ambiental del territorio. Al organizar esta información en
          un lenguaje común, contribuyen a que las instituciones trabajen de
          manera más coordinada y a que la ciudadanía pueda conocer mejor las
          reglas, valores y responsabilidades asociadas a los lugares donde
          vive, trabaja o desarrolla sus actividades.
        </p>
        <p className="font-serif text-2xl text-forest mt-8" data-id="element-441" data-mp="1skwb9gnxpege">
          Con los OTL, el territorio no solo se observa en un mapa: se entiende
          mejor, se administra con mayor claridad y se protege con mejores
          herramientas.
        </p>
      </div>
    </div>;
}